import { supabase } from './api'

// Get recognition | awardlistlevelcount
export async function getAwardsListLevelCount(studentId) {
	const { data, error } = await supabase.from('awardlistlevelcount').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch activity list level count')
	return data
}

// Get grade level | awardlistgradelevelcount
export async function getAwardsListGradeLevelCount(studentId) {
	const { data, error } = await supabase.from('awardlistgradelevelcount').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch activity list level count')
	return data
}

// get ranking | awardlistrankingcount
export async function getAwardsListRankingCount(studentId) {
	const { data, error } = await supabase.from('awardlistrankingcount').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch activity list position count')
	return data
}

// Overview – Table: awardlistdesc
export async function getOverviewTexts(studentId) {
	const { data, error } = await supabase.from('awardlistdesc').select().eq('studentId', studentId)

	if (error) {
		console.error('Supabase error:', error)
		throw new Error('Failed to fetch overview data')
	}

	return data
}

export async function saveOverviewTexts(studentId, overviewMap) {
	for (const [type, desc] of Object.entries(overviewMap)) {
		// Sadece bu type'ı sil
		const deleteRes = await supabase.from('awardlistdesc').delete().eq('studentId', studentId).eq('type', type)

		if (deleteRes.error) {
			console.error(`Error deleting overview for ${type}:`, deleteRes.error.message)
			throw new Error('Failed to delete previous overview data')
		}

		// Yeni overview satırını ekle
		const { error } = await supabase.from('awardlistdesc').insert([{ studentId, type, desc }])

		if (error) {
			console.error(`Error inserting overview for ${type}:`, error.message)
			throw new Error('Failed to insert new overview data')
		}
	}
}
